import React from "react";
import { Switch, Route } from "react-router-dom";
import { Header } from "./common/components/Header/header";
import HardwareDetailsPage from "./pages/hardware-details/hardware-details-page";
import SearchResultsHardwarePage from "./pages/hardware-search/hardware-search-page";
import { AppBoundaryReloadGuard } from "./routes/routes-helper";
import OrderConfirmationPage from "./pages/confirmation/order-confirmation-page";

const App: React.FC = () => {
  return (
    <>
      <AppBoundaryReloadGuard />
      <Header />
      <Switch>
        <Route exact path="/" component={SearchResultsHardwarePage} />
        <Route path="/items/*" component={HardwareDetailsPage} />
        <Route path="/confirmation" component={OrderConfirmationPage} />
      </Switch>
    </>
  );
};

export default App;
